/* eslint max-len: [error, 150] */
export default {
    cookie: {
        locale: 'uwrlocale'
    },
    i18n: {
        en: {
            datepicker: {
                done: 'Done',
                legendText: 'Bank holiday',
                months: 'January,February,March,April,May,June,July,August,September,October,November,December',
                monthsShort: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
                selectMonth: 'Select month',
                today: 'Today',
                todayAbbrev: 'Today',
                weekdaysShort: 'M,T,W,T,F,S,S'
            }
        },
        de: {
            datepicker: {
                done: 'Fertig',
                legendText: 'Bankfeiertag',
                months: 'Januar,Februar,M\xe4rz,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
                monthsShort: 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez',
                selectMonth: 'Monat ausw\xe4hlen',
                today: 'Heute',
                todayAbbrev: 'Heute',
                weekdaysShort: 'M,D,M,D,F,S,S'
            }
        },
        fr: {
            datepicker: {
                done: 'OK',
                legendText: 'Jour f\xe9ri\xe9',
                months: 'Janvier,F\xe9vrier,Mars,Avril,Mai,Juin,Juillet,Ao\xfbt,Septembre,Octobre,Novembre,D\xe9cembre',
                monthsShort: 'Janv,F\xe9vr,Mars,Avr,Mai,Juin,Juil,Ao\xfbt,Sept,Oct,Nov,D\xe9c',
                selectMonth: 'S\xe9lectionner un mois',
                today: 'Aujourd\'hui',
                todayAbbrev: 'auj.',
                weekdaysShort: 'L,M,M,J,V,S,D'
            }
        },
        it: {
            datepicker: {
                done: 'Fine',
                legendText: 'Giorno festivo',
                months: 'Gennaio,Febbraio,Marzo,Aprile,Maggio,Giugno,Luglio,Agosto,Settembre,Ottobre,Novembre,Dicembre',
                monthsShort: 'Gen,Feb,Mar,Apr,Mag,Giu,Lug,Ago,Set,Ott,Nov,Dic',
                selectMonth: 'Selezionare mese',
                today: 'Oggi',
                todayAbbrev: 'Oggi',
                weekdaysShort: 'L,M,M,G,V,S,D'
            }
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./loader/defaultConfig.js
// module id = 79
// module chunks = main